import {
  GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER_MOBILE,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export type TrustpilotBannerMobilePosition =
  | 'widget_before_search_form'
  | 'widget_after_search_form'
  | 'control'

const VARIANTS_MAP: Record<string, TrustpilotBannerMobilePosition> = {
  [OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_WIDGET_BEFORE_SEARCH_FORM]:
    'widget_before_search_form',
  [OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_WIDGET_AFTER_SEARCH_FORM]:
    'widget_after_search_form',
}

export function useTrustpilotBannerPositionMobile(): TrustpilotBannerMobilePosition {
  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER_MOBILE,
    true,
  )

  return VARIANTS_MAP?.[decisionObj?.variationKey] ?? 'control'
}
